import type { ApiResponseType, PaginatedResponseType } from '~/types/api'
import api, { apiData } from './api'

export interface ParameterType {
  id: number
  companyId?: string | null
  type: string
  key: string
  label: string
  parentId?: number | null
  status: number
  order: number
  meta?: Record<string, unknown> | null
  children?: ParameterType[] | null
  parent?: ParameterType | null
  createdAt: string
  updatedAt: string
}

export interface CreateParameterPayloadType {
  type: string
  key: string
  label: string
  parentId?: number
  status?: number
  order?: number
  meta?: Record<string, unknown>
}

export interface UpdateParameterPayloadType extends Partial<CreateParameterPayloadType> {}

export interface ParameterListParamsType {
  page?: number
  limit?: number
  type?: string
  key?: string
  label?: string
  parentId?: number
  withChildren?: number
  withParent?: number
}

export const parameterService = {
  async list(params?: ParameterListParamsType) {
    return apiData(api.get<ApiResponseType<PaginatedResponseType<ParameterType>>>('/parameters', { params }))
  },

  async get(id: number) {
    return apiData(api.get<ApiResponseType<ParameterType>>(`/parameters/${id}`))
  },

  async create(payload: CreateParameterPayloadType) {
    return apiData(api.post<ApiResponseType<ParameterType>>('/parameters', payload))
  },

  async createBulk(payload: CreateParameterPayloadType[]) {
    return apiData(api.post<ApiResponseType<ParameterType[]>>('/parameters/bulk', payload))
  },

  async update(id: number, payload: UpdateParameterPayloadType) {
    return apiData(api.put<ApiResponseType<ParameterType>>(`/parameters/${id}`, payload))
  },

  async delete(id: number) {
    return apiData(api.delete<ApiResponseType<boolean>>(`/parameters/${id}`))
  },

  /** Elimina varios parámetros de una vez. Los globales se omiten sin ser root. */
  async bulkDelete(ids: number[]) {
    return apiData(api.post<ApiResponseType<{ deleted: number; skipped: number }>>('/parameters/bulk-delete', { ids }))
  }
}
